import { Component, EventEmitter, Input, OnChanges, OnInit, Output, ViewEncapsulation } from '@angular/core';
// import { IKryptomonCardData } from './k-kryptomon-card.interface';
import { Ikryptomon, eElementType, eGender } from 'app/services/kryptomons/kryptomons.interface';
import { eShape } from '../../rank/rank.component';
import { IinfoIconSettings, eInfoIconType } from '../../info-icon/info-icon.interface';
import { eSize } from '../k-cards.component';
import { environment } from 'environments/environment';
import { getGender, getKryptomonFEPic } from 'app/services/kryptomons/kryptomons.utilities';
import { formatNum } from 'app/common/utils/number.util';
import { IKryptomonCardPriceSettings } from './k-kryptomon-card.interface';

@Component({
  selector: 'k-kryptomon-card',
  templateUrl: './k-kryptomon-card.component.html',
  styleUrls: ['./k-kryptomon-card.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class KKryptomonCardComponent implements OnInit, OnChanges {

  // @Input() data: IKryptomonCardData = {
  @Input() data: Ikryptomon;
  @Input() forcePic: string;
  @Input() disableIfNotBreedableYet: boolean = false;
  @Input() highlightOnHover: boolean = true;
  timeToBreed: Date;
  currentDate = new Date();
  pic: string;
  //  = {
  //   id: 'xxx',
  //   tokenId: '666',
  //   name: null,
  //   pic: null/* 'https://kryptomon-images.ams3.digitaloceanspaces.com/images/kryptomons/png/kmon_1000016089_png.png' */,
  //   dollarAmount: '$62.04',
  //   BNBAmount: '0.02',
  //   speciality: 'Defence',
  //   elementType: eElementType.Air,
  //   elementTypeSecond: eElementType.Electro,
  //   genes: {
  //     generation: '10',
  //     sex: '6'
  //   },
  //   gameMetadata: {
  //     isFreezed: 0
  //   },
  //   extraMarketData: {
  //     breedingCount: '2',
  //     breedingsLeft: '8'
  //   },
  //   orders: [],
  //   ranking: 630,
  //   hatch: false,
  //   status: 1
  // };
  @Input() isBreedingVisible: boolean = true;
  @Input() isResponsive: boolean = true;
  @Input() size: eSize = eSize.sm;
  @Output() onCardClick: EventEmitter<Ikryptomon> = new EventEmitter<Ikryptomon>();
  // @Input() BNBAmount: string;
  // @Input() dollarAmount: string;
  // @Input() KMONvalue: number;
  @Input() priceSettings: IKryptomonCardPriceSettings;
  _dollarAmount: string;
  _kmonPrice: string;
  @Input() isPriceVisible: boolean = false;
  rankShape: eShape = eShape.rectangle;
  rankSize: eSize = eSize.xxs;
  _elementTypeSettings: IinfoIconSettings;
  _elementTypeSecondSettings: IinfoIconSettings;
  _breedingCount: IinfoIconSettings;
  _gender: IinfoIconSettings;
  _generation: IinfoIconSettings;



  ngOnInit(): void {
    this.ngOnChanges();
  }

  ngOnChanges() {
    if (this.data) {
      this._elementTypeSettings = {
        id: this.data.elementType,
        type: eInfoIconType.element
      };
      this._elementTypeSecondSettings = {
        id: this.data.elementTypeSecond,
        type: eInfoIconType.element
      };
      if (this.data.extraMarketData) {
        let totalBreeding: number = parseInt(this.data.extraMarketData.breedingCount, 10) + parseInt(this.data.extraMarketData.breedingsLeft, 10);
        this._breedingCount = {
          type: eInfoIconType.breeding,
          label: this.data.extraMarketData.breedingCount + '/' + totalBreeding
        };
        this.isBreedingVisible = !isNaN(totalBreeding);
      } else this.isBreedingVisible = false;
      this._gender = {
        type: eInfoIconType.gender,
        // id: parseInt(this.data.genes.sex, 10) <= 5 ? eGender.female : eGender.male
        id: getGender(this.data)
      };
      this._generation = {
        type: eInfoIconType.text,
        label: 'GEN: ' + this.data.genes.generation
      };
      if (!this.forcePic) {
        // switch (this.data.status) {
        //   case "0":
        //     this.data.pic = `./assets/img/${this.data.elementType}/${this.data.speciality.toLowerCase()}.png`
        //     break;
        //   case 1:
        //     this.data.pic = `${environment.apiImages}images/kryptomons/png/kmon_${this.data.tokenId}_png.png`
        //     break;
        //   case 2:
        //     this.data.pic = `${environment.apiImages}images/kryptomons-junior/png/kmon_${this.data.tokenId}_png.png`
        //     break;
        //   default:
        //     break;
        // }
        this.pic = getKryptomonFEPic(this.data.status, this.data.elementType, this.data.speciality, this.data.tokenId, this.data.extraData?.unfreezable);
      } else this.pic = this.forcePic;
      if (this.priceSettings) {
        this._dollarAmount = this.priceSettings.dollarAmount ? formatNum(this.priceSettings.dollarAmount) : formatNum(this.priceSettings.kmonValue * this.priceSettings.kmonPrice);
        this._kmonPrice = formatNum(this.priceSettings.kmonPrice);
      }
      this.timeToBreed = new Date(parseInt(this.data.extraMarketData?.timeCanBreed + '000'));
      if (this.disableIfNotBreedableYet) this.highlightOnHover = this.currentDate > this.timeToBreed;
    }
  }


  click() {
    if (this.disableIfNotBreedableYet) {
      if (this.currentDate > this.timeToBreed) this.onCardClick.emit(this.data);
    } else this.onCardClick.emit(this.data);
  }
}
